<template>
  <div class="actseckill" v-if="actseckill.list && actseckill.list.length">
    <div class="actCalendar pos-r">
      <div class="actImg">
        <img :src="actseckill.bgurl" alt="" class="w-100 h-100 of-c" />
      </div>
      <div class="pos-a t0 l0 time" v-if="time > 0">
        <van-count-down :time="time" class="h-100 flex jc-fe ai-c" @finish="getTime">
          <template #default="timeData" v-if="status == 1 && time > 0">
            <span class="colon fw-b">热抢中&nbsp;</span>
            <span class="date" v-if="timeData.days > 0">{{ timeData.days }}</span>
            <span class="colon ml2 mr2" v-if="timeData.days > 0">天</span>
            <span class="date">
              {{ timeData.hours >= 10 ? timeData.hours : '0' + timeData.hours }}
            </span>
            <span class="colon ml2 mr2">:</span>
            <span class="date">
              {{ timeData.minutes >= 10 ? timeData.minutes : '0' + timeData.minutes }}
            </span>
            <span class="colon ml2 mr2">:</span>
            <span class="date">
              {{ timeData.seconds >= 10 ? timeData.seconds : '0' + timeData.seconds }}
            </span>
          </template>
          <template #default="timeData" v-else-if="status == 0 && time > 0">
            <span class="colon fw-b">距开始&nbsp;</span>
            <span class="date" v-if="timeData.days > 0">{{ timeData.days }}</span>
            <span class="colon ml2 mr2" v-if="timeData.days > 0">天</span>
            <span class="date">{{ timeData.hours }}</span>
            <span class="colon ml2 mr2">时</span>
            <span class="date">{{ timeData.minutes }}</span>
            <span class="colon ml2">分</span>
            <span class="d-ib date" v-if="timeData.days <= 0">{{ timeData.seconds }}</span>
            <span class="d-ib colon ml4" v-if="timeData.days <= 0">秒</span>
          </template>
        </van-count-down>
      </div>
      <swiper :options="actseckillSwiper" class="pos-a actDetail" id="swiperActseckill">
        <swiper-slide class="h-100" v-for="(item, index) of actseckill.list" :key="index">
          <img :src="item.img_path" @click="actseckillHandle(index)" alt="" class="h-100 of-c" />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=18'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </swiper-slide>
      </swiper>
    </div>
    <div
      class="swiper-pagination customPagination flex jc-c mt5"
      id="actseckillSwiperPagination"
    ></div>
  </div>
</template>

<script>
import { isWeixin, getServerDate } from '../../../assets/common/js/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)

export default {
  props: {
    actseckill: {
      type: Object,
      default: function () {
        return {}
      }
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'ACTSECKILL'
    },
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      time: 0,
      status: 2, // 0未开始 1进行中 2已结束
      actseckillSwiper: {
        observer: true,
        observeParents: true,
        freeMode: true,
        slidesPerView: 4.1045,
        spaceBetween: 7,
        pagination: {
          el: '#actseckillSwiperPagination',
          type: 'bullets'
        }
      }
    }
  },
  mounted() {
    this.getTime()
  },
  beforeUpdate() {
    this.getTime()
  },
  methods: {
    actseckillHandle (index) {
      this.$emit('banner-click', this.actseckill.list[index], index, this.flow_area_prefix + '-' + (index + 1))
    },
    getTime() {
      if (!this.actseckill.endtime || !this.actseckill.starttime) return
      this.$nextTick(() => {
        const nowtime = new Date(getServerDate()).getTime()
        const endtime = new Date(this.actseckill.endtime.replace(/-/g, '/')).getTime()
        const starttime = new Date(this.actseckill.starttime.replace(/-/g, '/')).getTime()
        if (nowtime >= starttime && nowtime < endtime) {
          this.time = endtime - nowtime
          this.status = 1
        } else if (nowtime < starttime) {
          this.time = starttime - nowtime
          this.status = 0
        } else {
          this.time = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.actCalendar {
  height: 1.89rem;
}
.actImg {
  height: 100%;
  border-radius: 0.1rem;
}
.time {
  height: 0.38rem;
  right: 0.08rem;
  .colon {
    color: #494747;
    font-size: 0.11rem;
  }
  .date {
    border-radius: 0.04rem;
    min-width: 0.18rem;
    height: 0.18rem;
    color: #fff;
    font-size: 0.12rem;
    text-align: center;
    background-color: #494747;
  }
}
.actDetail {
  height: 1.44rem;
  bottom: 0.08rem;
  left: 0.07rem;
  right: 0.07rem;
  img {
    width: 100%;
    border-radius: 0.1rem;
  }
}
#actseckillSwiperPagination {
  left: 0.11rem;
  right: 0.11rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/actTimeLimit.vue